import React, { Component } from "react"
import { Link } from "gatsby"
import headerStyles from "../../styles/modules/header.module.scss"
import Scroll from "../scroll"

class NavLinks extends Component {
  constructor() {
    super();
    this.state = {
      openMenu: false,
      visibilityClass: '',
    };
  }

  toggleMenu = value => {
    this.setState({ openMenu: value });
  };

  handleScroll = () => {
    const { visibilityClass } = this.state;
    if (window.pageYOffset > 60) {
      if (visibilityClass !== 'navbar-shrink') {
        this.setState({ visibilityClass: 'navbar-shrink' });
      }
    } else {
      if (visibilityClass === 'navbar-shrink') {
        this.setState({ visibilityClass: '' });
      }
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { openMenu } = this.state

    return (
      <div id={headerStyles.sectionLinks}>
          <li className="nav-item">
            <Scroll
              onClick={_ => this.toggleMenu(!openMenu)}
              type="id"
              element="home"
            >
              <Link
                className={headerStyles.link}
                to="/#home"
                onClick={e => this.handleLinkClick(e, "#home")}
              >Home
              </Link>
            </Scroll>
          </li>

          <li className="nav-item">
            <Scroll
              onClick={_ => this.toggleMenu(!openMenu)}
              type="id"
              element="about"
            >
              <Link
                className={headerStyles.link}
                to="/#about-me"
                onClick={e => this.handleLinkClick(e, "#about")}
              >About
              </Link>
            </Scroll>
          </li>

          <li className="nav-item">
            <Scroll
              onClick={_ => this.toggleMenu(!openMenu)}
              type="id"
              element="projects"
            >
              <Link
                className={headerStyles.link}
                to="/#my-projects"
                onClick={e => this.handleLinkClick(e, "#projects")}
              >Projects
              </Link>
            </Scroll>
          </li>

          <li className="nav-item">
            <Scroll
              onClick={_ => this.toggleMenu(!openMenu)}
              type="id"
              element="blogs"
            >
              <Link
                className={headerStyles.link}
                to="/#blogs"
                onClick={e => this.handleLinkClick(e, "#blogs")}
              >Blogs
              </Link>
            </Scroll>
          </li>
      </div>
    )
  }
}

export default NavLinks
